module.exports = __webpack_public_path__ + "img/icon_paging_prev.b73673a6.svg";